export function buildGoogleMapsUrl(query) {
  const qs = new URLSearchParams({ api: '1', query });
  return `https://www.google.com/maps/search/?${qs.toString()}`;
}

